<script lang="ts">
  import RepositoryFactory, { SUB_CONTRACT_HIKARI01_TEL } from './../../../../repositories/RepositoryFactory';
  import { loginUser } from '../../../../components/auth/LoginUser';
  import { form, field } from 'svelte-forms';
  import { required } from 'svelte-forms/validators';

  let pageStatus: 'TOP' | 'INPUT' | 'CONFIRM' | 'COMPLETE' = 'TOP';

  const APPLICATION_TYPES = [
    { code: 'NEW_NUMBER', text: '新規番号採番' },
    { code: 'NUMBER_PORTABILITY', text: '番号ポータビリティを利用' }
  ];
  let applicationType: 'NEW_NUMBER' | 'NUMBER_PORTABILITY' = 'NEW_NUMBER';
  $: applicationTypeSelected = APPLICATION_TYPES.find((a) => a.code === applicationType).text;
  let isDisabledNumberPortability: boolean = true;
  let numberPortabilityClass: '' | 'required' = '';

  const numberPortabilityTelNo = field('numberPortabilityTelNo', '', [required()]);
  const numberPortabilityCompany = field('numberPortabilityCompany', '', [required()]);
  const myForm = form(numberPortabilityTelNo, numberPortabilityCompany);

  const OPTION_APPLICATIONS = [
    { code: 0, text: '申込みしない' },
    { code: 1, text: '申込みする' }
  ];
  let optionPack: number = 0;
  let optionNumberDisplay: number = 0;
  let optionCatchCall: number = 0;
  let optionCathcClallNumberDisplay: number = 0;

  $: optionPackSelected = OPTION_APPLICATIONS.find((o) => o.code === optionPack).text;
  $: optionNumberDisplaySelected = OPTION_APPLICATIONS.find((o) => o.code === optionNumberDisplay).text;
  $: optionCatchCallSelected = OPTION_APPLICATIONS.find((o) => o.code === optionCatchCall).text;
  $: optionCathcClallNumberDisplaySelected = OPTION_APPLICATIONS.find(
    (o) => o.code === optionCathcClallNumberDisplay
  ).text;

  const handleTransitionInput = (): void => {
    pageStatus = 'INPUT';
  };

  const handleTransitionConfirm = async () => {
    if (applicationType === 'NUMBER_PORTABILITY') {
      let isFormValid = false;
      await myForm.validate().then(() => {
        isFormValid = $myForm.valid;
      });
      if (!isFormValid) {
        return;
      }
    }
    pageStatus = 'CONFIRM';
  };

  $: getContentsEntered = () => {
    return `・申込する電話契約：いえのでんわ
・適用キャンペーン：いえのでんわスタートキャンペーン(TEL_START)
・申込方法：${applicationTypeSelected}
・番号ポータビリティする電話番号：${isDisabledNumberPortability ? '' : $numberPortabilityTelNo.value}
・番号ポータビリティする元事業者：${isDisabledNumberPortability ? '' : $numberPortabilityCompany.value}
・オプション
　・オプションパック：${optionPackSelected}
　・着信番号表示：${optionNumberDisplaySelected}
　・キャッチ通話：${optionCatchCallSelected}
　・キャッチ通話番号表示：${optionCathcClallNumberDisplaySelected}`;
  };

  const handleTransitionComplete = async () => {
    const contractRepository = RepositoryFactory[SUB_CONTRACT_HIKARI01_TEL];
    await contractRepository
      .applyIenodenwa({
        newOrNp: applicationTypeSelected,
        npTelNumber: $numberPortabilityTelNo.value,
        npPortoutCompany: $numberPortabilityCompany.value,
        opOptionPackFlg: optionPack,
        opSenderNumberDisplayFlg: optionNumberDisplay,
        opWarikomiFlg: optionCatchCall,
        opWarikomiDisplayFlg: optionCathcClallNumberDisplay,
        contentsEntered: getContentsEntered()
      })
      .then((res) => {
        pageStatus = 'COMPLETE';
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('エラーが発生しました。再度やり直してください。');
        }
      });
  };

  const onChangeApplicationType = (): void => {
    if (applicationType === 'NUMBER_PORTABILITY') {
      isDisabledNumberPortability = false;
      numberPortabilityClass = 'required';
    } else {
      isDisabledNumberPortability = true;
      numberPortabilityClass = '';
    }
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h2 class="text-xl font-bold text-gray-700">付帯契約(電話)の手続き</h2>
    </div>
  </div>
  {#if pageStatus === 'TOP'}<!-- トップ画面 -->
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex-1 m-10">
        <div class="mb:font-sm w-full">
          <p>契約中の電話契約はありません</p>
        </div>

        <div class="mt-28">
          <h3 class="text-lg font-bold">付帯契約(電話)の申込</h3>

          <div class="flex flex-col divide-y divide-gray-300 py-4">
            <!-- [Note] divideの線をだすためにからのdivタグを入れています -->
            <div />
            <div class="inline-grid grid-cols-3 justify-items-center items-center py-4">
              <div class="grid-1 col-span-2 justify-self-start">
                <span class="inline-block">いえのでんわを申込みする場合はこちら</span>
              </div>
              <div class="grid-1 justify-self-end">
                <button on:click={handleTransitionInput} class="button-primary"> 手続きへ </button>
              </div>
            </div>
            <div />
          </div>
        </div>
      </div>
    </div>
  {:else if pageStatus === 'INPUT'}<!-- 入力画面 -->
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex-1 m-10">
        <div class="mb:font-sm w-full">
          <p>いえのでんわの申込み</p>
          <p>以下の内容を確認、入力いただき、「手続きへ」を押下ください。</p>

          <div class="flex-1 my-4">
            <form>
              <div class="flex flex-col justify-items-center items-center">
                <div class="shadow rounded bg-gray-50 w-full content-center p-4">
                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title">申込する電話契約</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <p class="label-value">いえのでんわ</p>
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title">適用キャンペーン</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <p class="label-value">いえのでんわスタートキャンペーン(TEL_START)</p>
                      <p class="label-value">※自動適用させていただきます</p>
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title required">申込方法</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <select
                        class="form-select text-sm"
                        bind:value={applicationType}
                        on:change={onChangeApplicationType}
                      >
                        {#each APPLICATION_TYPES as app}
                          <option value={app.code}>{app.text}</option>
                        {/each}
                      </select>
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title {numberPortabilityClass}">番号ポータビリティする電話番号</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <input
                        type="tel"
                        maxlength="100"
                        bind:value={$numberPortabilityTelNo.value}
                        disabled={isDisabledNumberPortability}
                      />
                      {#if $myForm.hasError('numberPortabilityTelNo.required')}
                        <p class="text-red-500 text-xs mt-2">電話番号を入力してください</p>
                      {/if}
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title {numberPortabilityClass}">番号ポータビリティする元事業者</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <input
                        type="text"
                        maxlength="100"
                        bind:value={$numberPortabilityCompany.value}
                        disabled={isDisabledNumberPortability}
                      />
                      {#if $myForm.hasError('numberPortabilityCompany.required')}
                        <p class="text-red-500 text-xs mt-2">事業者名を入力してください</p>
                      {/if}
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-1 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title">オプション</span>
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title ml-4">オプションパック</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <select class="form-select text-sm" bind:value={optionPack}>
                        {#each OPTION_APPLICATIONS as option}
                          <option value={option.code}>{option.text}</option>
                        {/each}
                      </select>
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title ml-4">着信番号表示</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <select class="form-select text-sm" bind:value={optionNumberDisplay}>
                        {#each OPTION_APPLICATIONS as option}
                          <option value={option.code}>{option.text}</option>
                        {/each}
                      </select>
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title ml-4">キャッチ通話</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <select class="form-select text-sm" bind:value={optionCatchCall}>
                        {#each OPTION_APPLICATIONS as option}
                          <option value={option.code}>{option.text}</option>
                        {/each}
                      </select>
                    </div>
                  </div>

                  <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                    <div class="grid-1 justify-self-start w-full">
                      <span class="label-title ml-4">キャッチ通話番号表示</span>
                    </div>
                    <div class="grid-1 justify-self-start w-full">
                      <select class="form-select text-sm" bind:value={optionCathcClallNumberDisplay}>
                        {#each OPTION_APPLICATIONS as option}
                          <option value={option.code}>{option.text}</option>
                        {/each}
                      </select>
                    </div>
                  </div>
                  <div class="items-center min-w-full p-2 mt-4">
                    <ul class="list-none text-xs">
                      <li>
                        <p>※オプションパックをお申込みすると自動的に他のオプションをお申込みさせていただきます</p>
                      </li>
                      <li>
                        <p>※オプションは、電話サービス開始後でも、追加申込等が可能です</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="flex flex-col justify-items-center items-center">
          <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
            <button class="button-primary md:ml-5 mb-5" on:click={handleTransitionConfirm}> 手続きへ </button>
          </div>
        </div>
      </div>
    </div>
  {:else if pageStatus === 'CONFIRM'}<!-- 確認画面 -->
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex-1 m-10">
        <div class="mb:font-sm w-full">
          <p>いえのでんわの申込み</p>
          <p>以下の内容でお手続きを進めます。問題なければ、実行ボタンを押下ください。</p>

          <div class="flex flex-col justify-items-center items-center">
            <div class="shadow rounded bg-gray-50 w-full content-center p-4">
              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title">申込する電話契約</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">いえのでんわ</p>
                </div>
              </div>

              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title">適用キャンペーン</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">いえのでんわスタートキャンペーン(TEL_START)</p>
                  <p class="label-value">※自動適用させていただきます</p>
                </div>
              </div>

              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title">申込方法</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">{applicationTypeSelected}</p>
                </div>
              </div>

              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title">番号ポータビリティする電話番号</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">
                    {isDisabledNumberPortability ? '' : $numberPortabilityTelNo.value}
                  </p>
                </div>
              </div>

              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title">番号ポータビリティする元事業者</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">
                    {isDisabledNumberPortability ? '' : $numberPortabilityCompany.value}
                  </p>
                </div>
              </div>

              <div class="inline-grid grid-cols-1 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title">オプション</span>
                </div>
              </div>

              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title ml-4">オプションパック</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">{optionPackSelected}</p>
                </div>
              </div>

              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title ml-4">着信番号表示</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">{optionNumberDisplaySelected}</p>
                </div>
              </div>

              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title ml-4">キャッチ通話</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">{optionCatchCallSelected}</p>
                </div>
              </div>

              <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
                <div class="grid-1 justify-self-start w-full">
                  <span class="label-title ml-4">キャッチ通話番号表示</span>
                </div>
                <div class="grid-1 justify-self-start w-full">
                  <p class="label-value">
                    {optionCathcClallNumberDisplaySelected}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-items-center items-center">
          <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
            <button class="button-primary md:ml-5 mb-5" on:click|once={handleTransitionComplete}> 実行 </button>
          </div>
        </div>
      </div>
    </div>
  {:else if pageStatus === 'COMPLETE'}<!-- 完了画面 -->
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex-1 m-10">
        <div class="inline-flex justify-items-center items-center min-w-full mb-20">
          <div class="mb:font-sm w-full">
            <ul class="list-none mt-4">
              <li>
                <p>いえのでんわ申込みを受け付けました</p>
              </li>
              <li class="mt-2">
                <p>お手続きについてご不明な点がございましたら、以下からご連絡いただくようお願いいたします。</p>
              </li>
              <li>
                <p>URL：https://bb01.unext.co.jp/contact</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>

<style lang="postcss">
  .required:after {
    content: ' *';
    color: red;
  }

  p:not([class]) {
    @apply tracking-normal mb-1;
  }
  .label-title {
    @apply text-sm font-medium text-gray-700;
  }
  .label-value {
    @apply text-sm font-medium text-gray-900;
  }
  input[type='text'],
  input[type='tel'] {
    @apply rounded border py-2 px-3 text-sm placeholder-gray-400 focus:placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-transparent w-full;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }

  select {
    @apply rounded border py-2 px-3 focus:outline-none focus:ring-2 focus:ring-green-200 w-full;
  }
</style>
